import React from 'react';
import { withTheme } from 'styled-components';

const RemoveBookFromShelfIconOnHover = ({ width, height, theme }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="11.7727"
        y="1.87866"
        width="5.63636"
        height="15.0303"
        rx="1"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColorOnHover
        }
      />
      <rect
        x="19.2878"
        width="3.75757"
        height="16.9091"
        rx="0.5"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColorOnHover
        }
      />
      <rect
        x="23.749"
        y="2.66333"
        width="4.69696"
        height="14.4177"
        rx="0.5"
        transform="rotate(-9.21973 23.749 2.66333)"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColorOnHover
        }
      />
      <rect
        x="10.8334"
        y="17.8486"
        width="20.6666"
        height="1.87879"
        rx="0.5"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColorOnHover
        }
      />
      <circle
        cx="8.48484"
        cy="16.4392"
        r="7.98484"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .circleBackground
        }
      />
      <line
        x1="4.21799"
        y1="16.4787"
        x2="12.7513"
        y2="16.4787"
        stroke={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColorOnHover
        }
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default withTheme(RemoveBookFromShelfIconOnHover);
